<marketing [includeOptimizely]="includeOptimizely" [segmentIdOverride]="segmentIdOverride"></marketing>
@if (showHeadPlaceholder) {
  <div [innerHTML]="headPlaceholderHtml"></div>
}
<!-- `contents` is intentional: it removes the wrapper from the box tree so children
(e.g. the sticky countdown banner) are not trapped by its containing block.
Do not target this wrapper for layout/styling. See EPS-3771. -->
<div [class.hidden]="showHeadPlaceholder" [class.contents]="!showHeadPlaceholder">
  <ng-template #head></ng-template>
</div>
@if (formattedData) {
  @for (options of formattedData; track options) {
    <div *hideOnSale="options.data.styles" class="flex flex-col mx-auto" shortcodeRenderer>
      <ng-template aceInsertableHost [options]="options" [registry]="registryService"></ng-template>
    </div>
  }
}
@if (showAmbassadorModal) {
  <ambassador-modal></ambassador-modal>
}
<vision-modal></vision-modal>
<!-- Webinar Schedule Component, used for MTG brand -->
<webinar-schedule></webinar-schedule>
<email-capture [data]="emailCapture" [stickyEmailOverride]="stickyEmailOverride"></email-capture>
<!-- Site-wide Refer-A-Friend widget (EPS-4567). Mounted on every Vision page; stays inert unless the
     `referAFriendConfig` global is set, in which case a content-authored `.raf-trigger` button opens it. -->
<refer-a-friend-container [config]="referAFriendConfig"></refer-a-friend-container>
@if (!emailCapture?.showEmailCapture) {
  <phone-capture [data]="phoneCapture" [stickyPhoneOverride]="stickyEmailOverride"></phone-capture>
}
<exit-intent-modal
  [config]="exitIntentConfig">
</exit-intent-modal>
<ng-template #foot></ng-template>
